export const getMoodOfFive = (mood: number) => {
  return `${mood}/5`
}
